<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Helios Error Log</h4>
  <button
    nf-icon-button="secondary"
    icon="close"
    class="btn-bare close"
    ngbTooltip="Close"
    (click)="onDismissModal()"
  >
    Close
  </button>
</div>

<div class="modal-content">
  <div class="modal-body" hsDraggable="modal-dialog">
    <div
      id="error-log-viewer"
      class="d-flex flex-column pl-2 pr-2"
      *ngIf="isErrorLogNonEmpty$ | async; else noErrors"
    >
      <ng-container
        *ngFor="let heliosError of errorLog$ | async; trackBy: trackByErrorId"
      >
        <hs-error-details-card
          class="p-2"
          [heliosError]="heliosError"
        ></hs-error-details-card>
      </ng-container>
    </div>
  </div>

  <div
    class="modal-footer"
    *ngIf="isErrorLogNonEmpty$ | async"
    hsDraggable="modal-dialog"
  >
    <button
      nf-icon-button
      icon="content-copy"
      ngbTooltip="Copy errors to clipboard"
      (click)="onCopy()"
    >
      Copy
    </button>
    <button
      nf-button="primary"
      ngbTooltip="Clear All Errors"
      (click)="onClearErrors()"
    >
      Clear All Errors
    </button>
  </div>
</div>

<ng-template #noErrors>
  <div id="empty-error-log">
    <p>No errors reported.</p>
  </div>
</ng-template>
